// Asegúrate de cargar estas librerías primero:
// <script src="https://code.jquery.com/jquery-3.6.0.min.js"></script>
// <script src="https://cdn.jsdelivr.net/npm/js-cookie@3.0.1/dist/js.cookie.min.js"></script>

// Función para cambiar herramientas de configuración
function switchConfigTools(e) {
  $("body").removeClass(
    "configDefaultTools configHighContrastTools configTextOnlyTools"
  );
  $('[data-type="configTools"]').removeClass("active");

  switch (e) {
    case "default":
      $('[data-typedes="default"]').addClass("active");
      $("body").addClass("configDefaultTools");
      break;
    case "highContrast":
      $('[data-typedes="highContrast"]').addClass("active");
      $("body").addClass("configHighContrastTools");
      break;
    case "textOnly":
      $('[data-typedes="textOnly"]').addClass("active");
      $("body").addClass("configTextOnlyTools");
  }
}

// Función para cambiar tamaño de fuente
function switchConfigFont(e) {
  $("body").removeClass("faFontLg faFont2x faFont3x");
  $('[data-type="configFont"]').removeClass("active");

  switch (e) {
    case "lg":
      $('[data-typedes="lg"]').addClass("active");
      $("body").addClass("faFontLg");
      break;
    case "2x":
      $('[data-typedes="2x"]').addClass("active");
      $("body").addClass("faFont2x");
      break;
    case "3x":
      $('[data-typedes="3x"]').addClass("active");
      $("body").addClass("faFont3x");
  }
}

// Función para leer cookies (compatible con js-cookie)
function readCookie(e) {
  return Cookies.get(e); // Usando js-cookie en lugar de la implementación manual
}

$(function () {
  // Configuración del menú
  $("header .u-menu .nav-menu .dropdown-menu").click(function (e) {
    e.stopPropagation();
  });

  // Configuración de enlaces
  $(".nxBlockEnlaces.typeList div[class^='constructEnlaces']").each(
    function () {
      var $nxBlock = $(this);
      $nxBlock.append('<ul class="list-unstyled lista-enlaces"></ul>');

      $nxBlock.find("a.section").each(function () {
        var $aSection = $(this);
        var $li = $("<li>");

        if ($aSection.next().is(".contentSection")) {
          $li.append($aSection).append($aSection.next());
        } else {
          $li.append($aSection);
        }

        $nxBlock.find("ul.lista-enlaces").append($li);
      });
    }
  );

  // Configuración de idioma (con verificación de carga)
  $("header .bloqueSesion .nxBlock").length && $("body").addClass("login-in");

  if (typeof Cookies !== "undefined") {
    // ← Verificación crucial
    var lang = Cookies.get("idioma");
    if (lang) {
      var detectarIdioma = "translate_" + lang;
      $("body").removeClass("translate_*").addClass(detectarIdioma);

      $(".lang_button").each(function () {
        var $btn = $(this);
        $btn.removeClass("lang_active");
        if ($btn.data("lang") === lang) {
          $btn.addClass("lang_active");
        }
      });
    }
  } else {
    console.error("Error: Librería js-cookie no cargada");
  }

  // Configuración del menú mega
  $("header .u-menu .nav-menu ul.megamenu > li").each(function () {
    if ($(this).find(".dropdown-menu").length) {
      $(this)
        .find("a.dropdown-toggle")
        .append('<span class="fa fa-chevron-down"></span>');
    }
  });

  // Configuración de iconos del menú
  $("header .u-menu .nav-menu ul.megamenu > li > a").each(function () {
    var icon = $(this).data("icon");
    if (icon !== undefined) {
      $(this).prepend('<i class="' + icon + '"></i>');
    }
  });

  // Botones de accesibilidad
  $("header .u-menu .nav-menu button").html('Menú <i class="fa fa-bars"></i>');

  $("#btnAccesibilidad__contraste").click(function () {
    $("body").toggleClass("configHighContrastTools");
    return false;
  });

  $("#btnAccesibilidad__minFontSize").click(function () {
    var currentSize = parseFloat($("body").css("font-size"), 10);
    var newSize = Math.max(16, currentSize - 1);
    $("body, html").css("font-size", newSize);
    return false;
  });

  $("#btnAccesibilidad__maxFontSize").click(function () {
    var currentSize = parseFloat($("body").css("font-size"), 10);
    var newSize = Math.min(22, currentSize + 1);
    $("body, html").css("font-size", newSize);
    return false;
  });

  $("#btnTopPage").click(function () {
    $("html, body").animate({ scrollTop: 0 }, "slow");
    return false;
  });

  $(".btnConfigTools").click(function (e) {
    e.preventDefault();
    var type = $(this).data("type");
    var typeDes = $(this).data("typedes");

    Cookies.set(type, typeDes, { path: "/" });

    if (type == "configTools") switchConfigTools(typeDes);
    if (type == "configFont") switchConfigFont(typeDes);
  });

  // Inicialización al cargar
  $(document).ready(function () {
    var configTools = Cookies.get("configTools");
    var configFont = Cookies.get("configFont");

    if (configTools) switchConfigTools(configTools);
    if (configFont) switchConfigFont(configFont);

    $("[data-toggle=popover]").popover();
    $("header").addClass("navbar-fixed-top");
    $("body").addClass("body-menu-fixed");

    $(window).scroll(function () {
      $("header").toggleClass("nxMenuFixed", $(this).scrollTop() > 103);
    });
  });
});
